import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { products } from '../../data/products';
import RelatedProducts from '../../components/RelatedProducts';
import { useCart } from '../../context/CartContext';

const Switch4in1Charger = () => {
  const product = products.find(p => p.id === 2) || products[1]; // 4-in-1 Nintendo Switch Charger
  const navigate = useNavigate();
  const { addToCart } = useCart();
  const [activeTab, setActiveTab] = useState('overview');
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [quantity, setQuantity] = useState(1);

  const images = [
    "/images/shop-products/4in1-nintendo-switch-charger/2188924075f8db26abdfac88cdef15ac.png", // 首图
    "/images/shop-products/4in1-nintendo-switch-charger/45655cf442bec96cc627713d28c8feca.png",
    "/images/shop-products/4in1-nintendo-switch-charger/5991bbdfe376b0f20c4a6c6313b4b826.png",
    "/images/shop-products/4in1-nintendo-switch-charger/5ec42b73852c480855072f480a28e775.png",
    "/images/shop-products/4in1-nintendo-switch-charger/61ad8f678947b3541f18ef7d43e52479.png",
    "/images/shop-products/4in1-nintendo-switch-charger/717d7632c77011b50915533f0ba189d5.png",
    "/images/shop-products/4in1-nintendo-switch-charger/9c4ca558bd7e309ba67e4d1845bd51b7.png"
  ];

  const handleAddToCart = () => {
    addToCart(product, quantity);
  };

  const handleBuyNow = () => {
    addToCart(product, quantity);
    navigate('/cart');
  };

  // Debug: Log images array
  console.log('🖼️ Total images:', images.length);
  console.log('🖼️ Images array:', images);
  console.log('🖼️ Product data:', product);

  const breadcrumbs = [
    { name: 'Home', href: '/' },
    { name: 'Nintendo Switch', href: '/category/nintendo-switch' },
    { name: product.name, href: '#' }
  ];


  return (
    <div className="min-h-screen bg-gray-900">
      {/* Breadcrumbs */}
      <nav className="bg-gray-800 py-4">
        <div className="container mx-auto px-4">
          <div className="flex items-center space-x-2 text-sm text-gray-300">
            {breadcrumbs.map((crumb, index) => (
              <React.Fragment key={crumb.name}>
                {index > 0 && <span>/</span>}
                <Link
                  to={crumb.href}
                  className="hover:text-white transition-colors"
                >
                  {crumb.name}
                </Link>
              </React.Fragment>
            ))}
          </div>
        </div>
      </nav>

      <div className="container mx-auto px-4 py-12 text-white">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
                     {/* Product Images */}
           <div className="space-y-4">
             <div className="aspect-square bg-gray-800 rounded-lg overflow-hidden">
               <img
                 src={images[currentImageIndex]}
                 alt={product.name}
                 className="w-full h-full object-cover"
                 onError={(e) => {
                   console.log('Main image failed to load:', images[currentImageIndex]);
                   e.target.src = 'https://via.placeholder.com/400x400/374151/9CA3AF?text=Product+Image';
                 }}
               />
             </div>
             <div className="grid grid-cols-4 gap-2">
               {images.map((image, index) => {
                 console.log(`Rendering thumbnail ${index + 1}:`, image);
                 return (
                   <button
                     key={index}
                     onClick={() => setCurrentImageIndex(index)}
                     className={`aspect-square bg-gray-800 rounded-lg overflow-hidden border-2 transition-colors ${
                       currentImageIndex === index ? 'border-green-500' : 'border-transparent'
                     }`}
                   >
                     <img
                       src={image}
                       alt={`${product.name} ${index + 1}`}
                       className="w-full h-full object-cover"
                       onError={(e) => {
                         console.log('❌ Image failed to load:', image);
                         e.target.src = 'https://via.placeholder.com/200x200/374151/9CA3AF?text=View+' + (index + 1);
                       }}
                       onLoad={() => console.log('✅ Image loaded successfully:', image)}
                     />
                   </button>
                 );
               })}
             </div>
           </div>

          {/* Product Details */}
          <div className="space-y-6">
            <div>
              <h1 className="text-4xl font-bold text-white mb-2">{product.name}</h1>
              <div className="flex items-center space-x-4 mb-4">
                <div className="flex items-center">
                  <div className="flex text-yellow-400">
                    {[...Array(5)].map((_, i) => (
                      <svg
                        key={i}
                        className={`w-5 h-5 ${i < Math.floor(product.rating) ? 'text-yellow-400' : 'text-gray-600'}`}
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                      </svg>
                    ))}
                  </div>
                  <span className="ml-2 text-gray-300">{product.rating}</span>
                </div>
                <span className="text-gray-400">({product.reviews} reviews)</span>
              </div>
            </div>

            <div className="space-y-4">
                             <div className="flex items-center space-x-4">
                 <span className="text-3xl font-bold text-white">{product.price}</span>
                 {product.originalPrice && product.originalPrice !== product.price && (
                   <span className="text-xl text-gray-400 line-through">{product.originalPrice}</span>
                 )}
                 {product.originalPrice && product.originalPrice !== product.price && (
                   <span className="bg-red-600 text-white px-2 py-1 rounded text-sm font-medium">
                     Save S${(parseFloat(product.originalPrice.replace(/^S\$/, '')) - parseFloat(product.price.replace(/^S\$/, ''))).toFixed(2)}
                   </span>
                 )}
               </div>

              <div className="flex items-center space-x-2">
                <span className={`w-3 h-3 rounded-full ${product.inStock ? 'bg-green-500' : 'bg-red-500'}`}></span>
                <span className={product.inStock ? 'text-green-400' : 'text-red-400'}>
                  {product.inStock ? 'In Stock' : 'Out of Stock'}
                </span>
              </div>

              <p className="text-gray-300 text-lg leading-relaxed">{product.description}</p>
            </div>

                         {/* Quantity Selector */}
             <div className="space-y-4">
               <div>
                 <label className="block text-sm font-medium text-gray-300 mb-2">Quantity</label>
                 <div className="flex items-center space-x-3">
                   <button
                     onClick={() => setQuantity(Math.max(1, quantity - 1))}
                     className="w-10 h-10 rounded-lg border border-gray-600 text-gray-300 hover:border-gray-400 transition-colors"
                   >
                     -
                   </button>
                   <span className="w-16 text-center text-lg font-medium">{quantity}</span>
                   <button
                     onClick={() => setQuantity(quantity + 1)}
                     className="w-10 h-10 rounded-lg border border-gray-600 text-gray-300 hover:border-gray-400 transition-colors"
                   >
                     +
                   </button>
                 </div>
               </div>
             </div>

                         {/* Action Buttons */}
             <div className="space-y-4">
               <button 
                 onClick={handleAddToCart}
                 className="w-full bg-green-600 hover:bg-green-700 text-white font-bold py-4 px-6 rounded-lg transition-colors"
               >
                 Add to Cart - S${(parseFloat(product.price.replace(/^S\$/, '')) * quantity).toFixed(2)}
               </button>
               <button 
                 onClick={handleBuyNow}
                 className="w-full bg-gray-700 hover:bg-gray-600 text-white font-bold py-4 px-6 rounded-lg transition-colors"
               >
                 Buy Now
               </button>
             </div>

            {/* Shipping Info */}
            <div className="bg-gray-800 p-4 rounded-lg">
              <div className="flex items-center space-x-3">
                <svg className="w-6 h-6 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                 <div>
                   <p className="font-medium text-white">Free Meet Up (Available at Sengkang & Orchard locations)</p>
                   <p className="text-sm text-gray-400">Available Shipping</p>
                 </div>
              </div>
            </div>

            {/* Meet Up Options */}
            <div className="bg-gray-800 p-4 rounded-lg">
              <div className="flex items-center space-x-3">
                <svg className="w-6 h-6 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                <div>
                  <p className="font-medium text-white">Meet Up Free</p>
                  <p className="text-sm text-gray-400">Available at Sengkang & Orchard locations</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Product Tabs */}
        <div className="mt-16">
          <div className="border-b border-gray-700">
            <nav className="flex space-x-8">
              {['overview', 'specifications', 'reviews'].map((tab) => (
                <button
                  key={tab}
                  onClick={() => setActiveTab(tab)}
                  className={`py-4 px-1 border-b-2 font-medium text-sm transition-colors ${
                    activeTab === tab
                      ? 'border-blue-500 text-blue-400'
                      : 'border-transparent text-gray-400 hover:text-gray-300 hover:border-gray-300'
                  }`}
                >
                  {tab.charAt(0).toUpperCase() + tab.slice(1)}
                </button>
              ))}
            </nav>
          </div>

          <div className="py-8">
            {activeTab === 'overview' && (
              <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
                <div className="lg:col-span-2">
                  <h2 className="text-2xl font-bold mb-4 text-white">4-in-1 Nintendo Switch Charger Overview</h2>
                  <div className="space-y-4 text-gray-300">
                    <p>
                      The 4-in-1 Nintendo Switch Charging Dock represents the ultimate charging solution for Nintendo Switch enthusiasts. 
                      Featuring simultaneous charging for Joy-Con controllers and Pro Controller, this dock delivers efficient power management 
                      while maintaining a compact design.
                    </p>
                    <p>
                      With fast charging technology and LED status indicators, you'll experience reliable charging performance that keeps 
                      your gaming sessions uninterrupted. The premium ABS construction ensures durability, while the compact design 
                      saves valuable desk space.
                    </p>
                    <p>
                      Perfect for gaming setups, travel, and home entertainment centers. The dock supports all Nintendo Switch controllers 
                      and provides a centralized charging station for your gaming accessories.
                    </p>
                  </div>
                </div>
                <div className="lg:col-span-1">
                  <h3 className="text-xl font-bold mb-4 text-white">Key Features</h3>
                  <div className="space-y-3">
                    {product.features.map((feature, index) => (
                      <div key={index} className="flex items-start">
                        <svg className="w-5 h-5 mr-3 text-green-500 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                        </svg>
                        <span className="text-gray-300">{feature}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}

            {activeTab === 'specifications' && (
              <div>
                <h2 className="text-2xl font-bold mb-6 text-white">4-in-1 Nintendo Switch Charger Specifications</h2>
                <div className="bg-gray-800 rounded-lg p-6">
                  <div className="space-y-4">
                    {Object.entries(product.specs).map(([key, value]) => (
                      <div key={key} className="flex justify-between py-3 border-b border-gray-700 last:border-b-0">
                        <span className="text-gray-300 font-medium">{key}:</span>
                        <span className="text-white">{value}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}

            {activeTab === 'reviews' && (
              <div className="space-y-6">
                <div className="flex items-center justify-between">
                  <h3 className="text-2xl font-bold text-white">Customer Reviews</h3>
                  <button className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg transition-colors">
                    Write a Review
                  </button>
                </div>
                
                <div className="space-y-4">
                  <div className="bg-gray-800 p-6 rounded-lg">
                    <div className="flex items-center justify-between mb-4">
                      <div className="flex items-center space-x-3">
                        <div className="w-10 h-10 bg-gray-600 rounded-full flex items-center justify-center">
                          <span className="text-white font-medium">JD</span>
                        </div>
                        <div>
                          <p className="font-medium text-white">John Doe</p>
                          <div className="flex text-yellow-400">
                            {[...Array(5)].map((_, i) => (
                              <svg key={i} className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                              </svg>
                            ))}
                          </div>
                        </div>
                      </div>
                      <span className="text-sm text-gray-400">2 days ago</span>
                    </div>
                    <p className="text-gray-300">
                      非常实用的充电器！可以同时为我的Switch和手柄充电，LED指示灯很清晰，充电速度也很快。
                      设计紧凑，不占地方，强烈推荐给Switch玩家！
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* 相关产品 */}
        <RelatedProducts 
          currentProductId={2} 
          currentCategory="nintendo-switch" 
          limit={4} 
        />
      </div>
    </div>
  );
};

export default Switch4in1Charger;
